export default __webpack_public_path__ + "static/media/sweden.a0fd41ba.svg";